module.exports = __webpack_public_path__ + "static/media/4e9.5d2b2fc6.jpg";